module.exports = __webpack_public_path__ + "img/powered.7696d87e.svg";